<template>
  <div>
    <v-row v-if="label">
      <v-col class="py-0">
        {{ label }}
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn-toggle
          v-model="value"
          density="compact"
          multiple
          :mandatory="mandatory"
          :class="[cssClass, {'full-width': xs}, 'filter-buttons']"
          style="background-color:inherit"
          @update:model-value="update"
        >
          <v-btn
            v-for="item in myOptions"
            :key="item.value"
            :value="item.value"
            :block="xs"
            color="primary"
            rounded="pill"
            border
            size="small"
            class="mr-2 mb-2"
          >
            <v-icon
              v-if="isCheckedItem(item.value)"
              tag="span"
              class="inverted-text"
              start
            >
              mdi-check
            </v-icon>
            {{ item.label }}
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useDisplay } from 'vuetify';

export default {
  name: "ButtonFilter",
  props: {
    options: Array,
    initial: Array,
    label: String,
    mandatory: Boolean,
    cssClass: String,
    clearing: Boolean
  },
  setup() {
    const { xs } = useDisplay();
    return { xs };
  },
  data() {
    return {
      value: this.initial,
      myOptions: this.options
    };
  },
  computed: {
    buttonClass() {
      if (this.cssClass?.includes("flex-md-row")) {
        return "mt-2 mt-md-0";
      }

      if (this.cssClass?.includes("flex-sm-row")) {
        return "mt-2 mt-sm-0";
      }

      return "";
    }
  },
  watch: {
    options(val) {
      this.myOptions = val;
    },
    clearing(val) {
      if (!val) {
        return;
      }

      this.clear();
      this.$emit("update:clearing", false);
    }
  },
  methods: {
    update: function (e) {
      this.$emit("input", e);
    },
    clear: function () {
      this.value = this.initial;
      this.$emit("input", this.value);
    },
    isCheckedItem(itemValue) {
      if(this.value) {
        return this.value.includes(itemValue);
      }

      return false;
    }
  }
};
</script>

<style scoped>
  .full-width {
    width: 100%;
  }
</style>
